export interface Product {
  id: string;
  name: string;
  age: number;
  collection: string | null;
  commodityLine: string;
  category: string;
  mrpId: string | null;
  mrpName: string | null;
  unit: string;
  type: string;
  urlImage: string | null;
  urlImage1: string | null;
  urlImage2: string | null;
  urlImage3: string | null;
  urlImage4: string | null;
  urlImage5: string | null;
  ttype: string | null;
  plantId: string | null;
  textScan: string | null;
  createDate: string;
  createId: string | null;
  modifyId: string | null;
  modifyDate: string;
}

export interface StorageLocation {
  productId: string;
  sloc: string;
  groupPrice: string;
  processPrice: number;
  totalInventory: number;
  goldenRatioThread: number;
  itemRatioThread: number;
  itemRatioGram: number;
  batch: string;
  unitPrice: number;
  unitPriceByGram: number;
  totalPrice: number;
  productName: string;
  tproducts: Product;
}
export interface GetProductParams {
  skip: number;
  take: number;
}

export const PRODUCT_VARIABLE = {
  getProductSloc: (params: GetProductParams & Partial<Product>) => {
    const {
      skip,
      take,
      plantId,
      ttype,
      id,
      name,
      type,
      age,
      commodityLine,
      unit,
    } = params;
    return {
      data: {
        skip,
        take,
        input: {
          ...(plantId && {
            plantId: {
              equals: plantId,
            },
          }),
          ...(id && {
            id: {
              equals: id,
            },
          }),
          ...(name && {
            name: {
              contains: name,
            },
          }),
          ...(type && {
            type: {
              equals: type,
            },
          }),
          ...(unit && {
            unit: {
              equals: unit,
            },
          }),
          ...(commodityLine && {
            commodityLine: {
              equals: commodityLine,
            },
          }),
          ...(age && {
            age: {
              equals: age,
            },
          }),
          ...(ttype && {
            ttype: {
              id: { equals: ttype },
            },
          }),
        },
      },
    };
  },

  getProductByFilter: (
    params: GetProductParams &
      Partial<StorageLocation> & {
        sloc?: string;
        batch?: string;
        plantId?: string;
        productId?: string;
        groupPrice?: string;
        productName?: string;
        age?: number;
        unit?: string;
        type?: string;
      },
  ) => {
    const {
      skip,
      take,
      plantId,
      sloc,
      batch,
      productId,
      groupPrice,
      productName,
      age,
      unit,
      type,
    } = params;

    return {
      skip: skip,
      take: take,
      input: {
        ...(plantId && {
          plantId: plantId,
        }),
        ...(sloc && {
          sloc: sloc,
        }),
        ...(batch && {
          batch: batch,
        }),
        ...(groupPrice && {
          groupPrice: groupPrice,
        }),
        ...(productId && {
          productId: productId,
        }),
        ...(productName && {
          productName: productName,
        }),
        ...(age && {
          age: age,
        }),
        ...(unit && {
          unit: unit,
        }),
        ...(type && {
          type: type,
        }),
      },
    };
  },

  getProduct: (
    params: GetProductParams &
      Partial<StorageLocation> & {
        collection?: string;
        commodityLine?: string;
        plantId?: string;
        id?: string;
        type?: string;
        name?: string;
        age?: number;
        unit?: string;
      },
  ) => {
    const { skip, take, collection, commodityLine, id, type, name, age, unit } =
      params;

    return {
      skip: skip || 0,
      take: take || 25,
      input: {
        ...(id && {
          productId: id,
        }),
        ...(name && {
          productName: name,
        }),
        ...(unit && {
          unit: unit,
        }),
        ...(type && {
          type: type,
        }),
        ...(age && {
          age: age,
        }),
        ...(collection && {
          collection: collection,
        }),
        ...(commodityLine && {
          commodityLine: commodityLine,
        }),
      },
    };
  },
  getListBatchComboboxVariables: (params: {
    pageSize: number;
    batch?: string;
  }) => {
    return {
      skip: 0,
      take: params.pageSize,
      input: {
        batch: { contains: params.batch },
      },
    };
  },
  getListSlocCbxVariables: (params: { pageSize: number; sloc?: string }) => {
    return {
      skip: 0,
      take: params.pageSize,
      input: {
        sloc: { contains: params.sloc },
      },
    };
  },
  getListCMDCbxVariables: (params: {
    pageSize: number;
    commodityLine?: string;
  }) => {
    return {
      skip: 0,
      take: params.pageSize,
      input: {
        commodityLine: { contains: params.commodityLine },
      },
    };
  },
  getListAgeCbxVariables: (params: { pageSize: number; age?: number }) => {
    return {
      skip: 0,
      take: params.pageSize,
      input: {
        ...(params.age !== 0 && { age: { equals: params.age } }),
      },
    };
  },
};
